import { isDesmet ,isVishaka} from "Utils/index";

export default class RFQDetails {
   constructor(rfqDetails = {}) {
      this.name = rfqDetails.rfq_name;
      this.contractTenureFrom = new Date(rfqDetails.contract_tenure.from).setHours(0, 0, 0, 0);
      this.contractTenureTo = (isDesmet() && !rfqDetails.contract_tenure.to) ? new Date().setDate(new Date().getDate() + 4) : rfqDetails.contract_tenure.to;
      this.serviceType = rfqDetails.service_type || 1;
      this.serviceTypeName = rfqDetails.service_type_name || 'FTL';
      this.serviceCategoryType = rfqDetails.service_category_type || 1;
      this.serviceCategoryTypeName = rfqDetails.service_category_type_name || 'Sea Freight';
      this.serviceModes = (rfqDetails.service_modes && rfqDetails.service_modes.length) ? rfqDetails.service_modes : (isVishaka() ? (this.serviceType === 1 ? [1] : [5]) : []);
      this.serviceModeName = rfqDetails.service_mode_name || ((rfqDetails.service_modes || [])[0] || {}).name || '';
      this.insuranceBy = rfqDetails.insurance_by == 0 ? 1 : rfqDetails.insurance_by;
      this.allowBidding = rfqDetails.bidding_details.is_allow_bidding;
      this.acceptPartialSolution = rfqDetails.bidding_details.is_accept_partial_solution;
      this.biddingPercentageSolution = rfqDetails.bidding_details.is_bidding_percentage_solution;
      this.biddingStart = rfqDetails.bidding_start;
      this.biddingEnd = rfqDetails.bidding_end;
      this.floated = rfqDetails.floated;
      this.floatedBy = rfqDetails.floated_by;
      this.documentType = rfqDetails.courier_document_details ? rfqDetails.courier_document_details.courier_document_type : 2;
      this.documentName = rfqDetails.courier_document_details ? rfqDetails.courier_document_details.courier_document_name : 'Non Document';
      this.movementType = rfqDetails.movement_type;
      this.tripsType = rfqDetails.trips_type || 1;
      this.tripsCount = rfqDetails.trips_count || 1;
      this.contractNote = rfqDetails.contract_note || '';
      this.subplant_name = rfqDetails.subplant_name || undefined;
      this.multiLevelMovementType = rfqDetails.multi_level_movement_type;
      this.shippingType = rfqDetails.shipping_type;
      this.otherCosts = rfqDetails.includes_other_charges || false;
      this.bidCompletedCount = rfqDetails.bid_complete_count;
      this.bidPendingCount = rfqDetails.bid_pending_count;
      this.allBidsCompleted = rfqDetails.all_bids_completed;
      this.secondaryContractType = rfqDetails.secondary_contract_type || 2;
		this.courierPriceWeight = rfqDetails.courier_price_weight;
      this.courierTatWeight = rfqDetails.courier_tat_weight;
     this.courierBidStatus=rfqDetails.courier_bid_status;
      this.cha_id = rfqDetails.cha_id;
      this.cha_name = rfqDetails.cha_name;
      this.rfq = rfqDetails.rfq
      this.rfqTypeLtc= rfqDetails.rfq_type_ltc;
      this.boundType= rfqDetails.bound_type || 2;
      this.dedicatedType= rfqDetails.dedicated_type || 2;
      this.tripLevelTransporter = rfqDetails.trip_level_transporter || false;
      this.fuelTypes = rfqDetails.fuel_type;
      this.fuelName = rfqDetails.fuel_name || "NA";
      this.incoTerms = rfqDetails.incoTerms || 2;
      this.incoTermsName = rfqDetails.incoTerms_name || 'Ex Works';
      this.spotContractReason = rfqDetails.spot_contract_reason || "";
      this.spotContractReasonId = rfqDetails.spot_contract_reason_id;
      this.rfqLevelSeekerRemarks = rfqDetails.rfq_level_seeker_remarks || '';
      this.tk11Table = rfqDetails.tk11_table || 1;
      this.movementTypeName = rfqDetails.movement_type_name || '';
      this.movementType = rfqDetails.movement_type || '';
      this.biddingType = rfqDetails.bidding_type || 1;
      this.withPincode = rfqDetails.with_pincode;
      this.contractType = rfqDetails.contract_type;
      this.contractTypeName = rfqDetails.contract_type_name;
      this.otherRemarks = rfqDetails.other_remarks;
      this.ftlContractType = rfqDetails.ftl_contract_type;
      this.enablePincodeColumns = rfqDetails.enable_pincode_columns;
      this.validatePincodeOnUpload = rfqDetails.validate_pincode_on_upload;
      this.vendorBiddingScreenId = rfqDetails.vendor_bidding_screen_id;
      this.vendorBiddingScreen = rfqDetails.vendorBiddingScreen;
      this.disposalContractType = rfqDetails.disposal_contract_type || 1;
      this.project_details = rfqDetails.project_details || {};
      this.material_packing_list = rfqDetails.material_packing_list || [];
      this.contact_details = rfqDetails.contact_details || {};
      this.supplier_docs = rfqDetails.supplier_docs || [];
      this.supplier_instruction = rfqDetails.supplier_instruction || "";
      this.supplier_number = rfqDetails.supplier_number || "";
      this.supplier_rfq = rfqDetails.supplier_rfq || "";
      this.supplier_rfq_id = rfqDetails.supplier_rfq_id || "";
      this.product_category_name = rfqDetails.product_category_name || "";
      this.tk11_type = rfqDetails.tk11_type || ""
      this.tk11_type_name = rfqDetails.tk11_type_name || ""
      this.sales_organisation_type = rfqDetails.sales_organisation_type || []
   }
   setName = (name) => {
      this.name = name;
   }
   setTk11Type = (type, typeName) => {
      this.tk11_type = type
      this.tk11_type_name = typeName
   }
   setSalesOrgType = (value) => {
      this.sales_organisation_type = value
   }
   setMovementType = (movementType, movementTypeName) => {
      this.movementType = movementType;
      this.movementTypeName = movementTypeName;
   }
   setDocumentType = (type) => {
      this.documentType = type;
      this.documentName = type === 1 ? 'Document' : 'Non Document'
   }
   setContractTenureFrom = (contractTenureFrom) => {
      this.contractTenureFrom = new Date(contractTenureFrom).setHours(0, 0, 0, 0);
   }
   setContractTenureTo = (contractTenureTo) => {
      this.contractTenureTo = contractTenureTo;
   }
   setServiceType = (serviceType, serviceTypeName) => {
      this.serviceType = serviceType;
      this.serviceTypeName = serviceTypeName;
   }
   setServiceModesCategory = (serviceModes) => {
      this.serviceModes = serviceModes;
   }
   setInsuranceBy = (insuranceBy) => {
      this.insuranceBy = insuranceBy;
   }
   setServiceModesArray = (modes) => {
   this.serviceModes = modes;
   }
   setServiceCategoryType = (serviceCategoryType, serviceCategoryTypeName) => {
      this.serviceCategoryType = serviceCategoryType;
      this.serviceCategoryTypeName = serviceCategoryTypeName;
   }
   setAllowBidding = (allowBidding) => {
      this.allowBidding = allowBidding;
   }
   setAcceptPartialSolution = (acceptPartialSolution) => {
      this.acceptPartialSolution = acceptPartialSolution;
   }
   setTripsType = (tripsType) => {
      this.tripsType = tripsType;
   }
   setContractNote = (contractNote) => {
      this.contractNote = contractNote;
   }
   setRfqLevelSeekerRemarks = (value) => {
      this.rfqLevelSeekerRemarks = value;
   }
   setMultiLevelMovementType = (multiLevelMovementType) => {
      this.multiLevelMovementType = multiLevelMovementType
   }
   setShippingType = (shippingType) => {
      this.shippingType = shippingType;
   }
   setOtherCosts = (otherCosts) => {
      this.otherCosts = otherCosts;
   }
   setSecondaryContractType = (secondaryContractType) => {
      this.secondaryContractType = secondaryContractType;
   }
	setCourierPriceWeight = (price) => {
		this.courierPriceWeight = price;
	}
	setCourierTatWeight = (tat) => {
		this.courierTatWeight = tat;
   }

   setCHAValue = (value) => {
      this.cha_name = value.cha_name;
      this.cha_id = value.cha_id;
   }

   setBoundType = (boundType) => {
      this.boundType = boundType;
   }

   setTransporterSelection = (value) => {
      this.tripLevelTransporter = value;
   }

   setContractRFQTypeLTC =(value)=>{
      this.rfqTypeLtc = value;
   }
   setDisablePartialSolution =(value)=>{
      this.disablePartialSolution=value;
   }
   
   setDedicatedType=(dedicatedType) =>{
      this.dedicatedType = dedicatedType;
   }

   setFuelType = (fuelTypes)=> {
      this.fuelTypes = fuelTypes.value;
      this.fuelName = fuelTypes.name;
   }

  setIncoTerms = (id, name) => {
   this.incoTerms = id;
   this.incoTermsName = name;
  }

  setContractType = (contract) => {
   this.contractType = contract.id;
   this.contractTypeName = contract.name;
   }

   setContractTypeDetails = (contract) => {
      this.contractType = contract.value;
      this.contractTypeName = contract.label;
   }

  setSpotContractReason = (reason) => {
   this.spotContractReason = reason.name;
   this.spotContractReasonId = reason.id;
  }

  setTK11Table = (value) => {
     this.tk11Table = value;
  }

  setDisposalContractType = (id) => {
   this.disposalContractType = id;
  }

  setBiddingType = (type) => {
   this.biddingType = type;
  }

  setWithPincode = (type) => {
   this.withPincode = type;
  }

  setOtherRemarks = (val) => {
   this.otherRemarks = val;
  }

  setftlContractType = (type) => {
   this.ftlContractType = type;
  }

  setVendorBiddingStatus = (val) => {
   this.vendorBiddingScreenId = val.id;
   this.vendorBiddingScreen = val.name;
  }

  setServiceModes = (el) => {
   this.serviceModeName = el.name;
   this.serviceModes = el.id && [el.id] || [];
}

setProcurementServiceModes = (el) => {
   this.serviceModeName = el.name;
   this.serviceModes = el.id && [el.id] || [];
}

   getApiData = () => {
      return {
         rfq_name: this.name,
         multi_level_movement_type: this.multiLevelMovementType,
         shipping_type: this.shippingType,
         includes_other_charges: this.otherCosts,
         secondary_contract_type: this.secondaryContractType,
			courier_price_weight: Number(this.courierPriceWeight),
         courier_tat_weight: Number(this.courierTatWeight),
         contract_tenure: {
            from: new Date(this.contractTenureFrom).setHours(0, 0, 0, 0),
            to: this.contractTenureTo ? new Date(this.contractTenureTo).setHours(23, 59, 59) : null,
            movement_type: this.movementType,
            movement_type_name: this.movementTypeName,
         },
         service_type: this.serviceType,
         service_type_name: this.serviceTypeName,
         service_category_type: this.serviceCategoryType,
         service_category_type_name: this.serviceCategoryTypeName,
         service_mode: this.serviceModes || [],
         service_mode_name: this.serviceModeName,
         insurance_by: this.insuranceBy,
         bidding_details: {
            is_allow_bidding: this.allowBidding,
            is_accept_partial_solution: this.acceptPartialSolution
         },
         contract_note: this.contractNote,
         rfq_level_seeker_remarks: this.rfqLevelSeekerRemarks,
         trips_type: this.tripsType,
         subplant_name: this.subplant_name ? this.subplant_name : undefined,
         courier_document_details: this.serviceType === 3 ? {
            document_type: this.documentType,
            document_name: this.documentName
         } : undefined,
         cha_id: this.cha_id,
         cha_name: this.cha_name,
         rfq_type_ltc : this.rfqTypeLtc,
         bound_type: this.boundType,
         dedicated_type : this.dedicatedType,
         trip_level_transporter: this.tripLevelTransporter,
         fuel_type: this.fuelTypes,
         contract_type: this.contractType,
         contract_type_name: this.contractTypeName,
         incoTerms: this.incoTerms,
         incoTerms_name: this.incoTermsName,
         spot_contract_reason: this.spotContractReason,
         spot_contract_reason_id: this.spotContractReasonId,
         tk11_table: this.tk11Table,
         bidding_type: this.biddingType,
         with_pincode: this.withPincode,
         other_remarks: this.otherRemarks,
         ftl_contract_type: this.ftlContractType,
         vendor_bidding_screen_id: this.vendorBiddingScreenId,
         vendor_bidding_screen: this.vendorBiddingScreen,
         disposal_contract_type: this.disposalContractType,
         tk11_type : this.tk11_type,
         tk11_type_name : this.tk11_type_name,
         sales_organisation_type:this.sales_organisation_type
      }
   }
}